export default __webpack_public_path__ + "static/media/permata_bank.5bd1e3de.png";